import { Injectable, inject } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@ngneat/transloco';
import { filter, merge } from 'rxjs';

/** Material paginator labels ("Items per page", "1 – 10 of 50", ...) in the active language */
@Injectable()
export class TranslatedPaginatorIntl extends MatPaginatorIntl {
    private _transloco = inject(TranslocoService);

    constructor() {
        super();
        this._update();
        // The language file may load after the switch, so refresh on both
        merge(
            this._transloco.langChanges$,
            this._transloco.events$.pipe(filter(e => e.type === 'translationLoadSuccess')),
        ).subscribe(() => this._update());
    }

    override getRangeLabel = (page: number, pageSize: number, length: number): string => {
        const of = this._transloco.translate('paginator.of');
        if (length === 0 || pageSize === 0) {
            return `0 ${of} ${length}`;
        }
        length = Math.max(length, 0);
        const start = page * pageSize;
        const end = start < length ? Math.min(start + pageSize, length) : start + pageSize;
        return `${start + 1} – ${end} ${of} ${length}`;
    };

    private _update(): void {
        const t = (k: string) => this._transloco.translate(`paginator.${k}`);
        this.itemsPerPageLabel = t('itemsPerPage');
        this.nextPageLabel = t('nextPage');
        this.previousPageLabel = t('previousPage');
        this.firstPageLabel = t('firstPage');
        this.lastPageLabel = t('lastPage');
        this.changes.next();
    }
}
